package pl.michal_cyran.brand_hub.subpages.main.hero

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.FaPlay
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroBadgeDotStyle
import pl.michal_cyran.brand_hub.HeroBadgeStyle
import pl.michal_cyran.brand_hub.HeroButtonsStyle
import pl.michal_cyran.brand_hub.HeroDescriptionStyle
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.HeroSocialStyle
import pl.michal_cyran.brand_hub.HeroTitleStyle
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.components.widgets.SecondaryButton
import pl.michal_cyran.brand_hub.toSitePalette


import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

// Small helper so every block follows the exact same fade+rise pattern
// used across the tutoring composables (opacity + translateY + EaseOut).
private fun Modifier.revealOnVisible(isVisible: Boolean, delayMs: Int): Modifier =
    this
        .opacity(if (isVisible) 1 else 0)
        .transform { translateY(if (isVisible) 0.px else 16.px) }
        .transition(
            Transition.of("opacity", 0.5.s, EaseOut, delayMs.ms),
            Transition.of("transform", 0.5.s, EaseOut, delayMs.ms)
        )

@Composable
fun MainHeroSection() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {
        VisibilityAware(
            modifier = Modifier
        ) { isVisible ->
            Column {
                // Badge
                Div(
                    HeroBadgeStyle.toModifier()
                        .revealOnVisible(isVisible, 0)
                        .toAttrs()
                ) {
                    Span(HeroBadgeDotStyle.toModifier().toAttrs()) {}
                    SpanText(
                        "Dostępny na korepetycje",
                        modifier = Modifier
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Medium)
                            .color(cm.primary)
                    )
                }

                // Title
                H1(
                    HeroTitleStyle.toModifier()
                        .revealOnVisible(isVisible, 120)
                        .toAttrs()
                ) {
                    Text("Matematyka na ")
                    Span(Modifier.color(cm.primaryMuted).toAttrs()) {
                        Text("wyciągnięcie")
                    }
                    Text(" ręki")
                }

                // Description
                P(
                    HeroDescriptionStyle.toModifier()
                        .revealOnVisible(isVisible, 240)
                        .toAttrs()
                ) {
                    Text("Korepetycje z matematyki, aplikacja mobilna, zadania maturalne i usługi freelance. Wszystko czego potrzebujesz w jednym miejscu.")
                }

                // CTA Buttons
                Row(
                    HeroButtonsStyle.toModifier()
                        .revealOnVisible(isVisible, 360),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    PrimaryButton(
                        path = "#korepetycje",
                        text = "Umów korepetycje",
                        icon = { FaArrowRight() }
                    )

                    SecondaryButton(
                        path = "#aplikacja",
                        text = "Zobacz aplikację",
                        icon = { FaPlay() },
                    )
                }

                // Social row
                Row(
                    HeroSocialStyle.toModifier()
                        .revealOnVisible(isVisible, 460)
                ) {
                    SpanText(
                        "Znajdź mnie:",
                        modifier = Modifier.fontSize(14.px)
                    )
                    SocialLinks()
                }
            }
        }

        HeroVisual()
    }
}